/* GlobalUndoToast.jsx — singleton mount of the calm Undo pill.
 *
 * Mount once at the App root. Any component can call
 * `showUndoToast({ label, onUndo })` from the global store and
 * the toast appears at the bottom-right of the viewport. Reuses
 * the existing `<UndoToast>` portal-based visual.
 */
import { UndoToast } from "./UndoToast";
import { useUndoToast, dismissUndoToast } from "../../lib/undoToastStore";

export function GlobalUndoToast() {
  const state = useUndoToast();
  return (
    <UndoToast
      open={!!state}
      label={state?.label || ""}
      onUndo={async () => {
        const fn = state?.onUndo;
        dismissUndoToast();
        if (typeof fn === "function") {
          try { await fn(); } catch { /* calm — never alarm */ }
        }
      }}
      onDismiss={dismissUndoToast}
      testid="global-undo-toast"
    />
  );
}
